// NDA.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../config/axiosConfig';

// Configuration des couleurs (identique à PolitiqueConfidentialite)
const T = {
  bg: '#0A0A0F',
  text: '#F1F5F9',
  textMuted: '#94A3B8',
  textFaint: '#64748B',
  border: '#1E293B',
  orange: '#FDBA74',
  orangeDim: 'rgba(253,186,116,0.08)',
  surfaceAlt: '#0F172A',
  emerald: '#34D399',
  sky: '#38BDF8',
  red: '#F87171',
};

// Contenu du NDA
const NDA_CONTENT = `ACCORD DE NON-DIVULGATION (NDA)
ENTRE PESACORE ARCHITECT ET TESTEUR BÉTA

PESACORE Architect SAS,
Siège social: 55 rue Grignan, 13006 MARSEILLE, 
immatriculée au RCS de Marseille, numéro 104 973 771
représentée par Anna AIT-MAHREZ en sa qualité de Présidente,

1. OBJET DE L'ACCORD
Le présent Accord de Non-Divulgation (ci-après "NDA") régit les conditions dans lesquelles PESACORE Architect (ci-après "la Société") confie au Testeur Bêta (ci-après "le Testeur") l'accès à sa plateforme, ses codes sources, algorithmes, spécifications techniques, données de test, fonctionnalités non publiées et toute information relative aux produits "PESACORE", "ParcoursCreator", "CaseCreator", "AtelierCreator", aux dashboards apprenants et administrateurs, ainsi qu'aux simulateurs (ci-après "les Informations Confidentielles").

1 bis. Qualification du Testeur. Le Testeur reconnaît et accepte que sa qualité de Testeur Bêta est définie par l'accès à la plateforme et par l'usage qu'il en fait dans le cadre du programme de test, conformément à l'article 3.1. Cette qualité est indépendante de toute intention, démarche ou négociation commerciale ultérieure, y compris si le Testeur envisage une collaboration avec la Société. Toute démarche de partenariat ou de collaboration commerciale fera l'objet d'un accord distinct, sans que le présent NDA ne soit affecté.

2. DÉFINITION DES INFORMATIONS CONFIDENTIELLES
Sont considérées comme Informations Confidentielles, quels que soient leur support et leur forme :
• Les codes sources, algorithmes, logiques métier et architectures techniques ;
• Les fonctionnalités en cours de développement ou en phase de test ;
• Les rapports de bug, vulnérabilités identifiées et axes d'amélioration ;
• Les données synthétiques, métriques de performance, résultats de simulation ;
• Les stratégies produit, feuilles de route, spécifications non publiées ;
• Toute information expressément désignée comme confidentielle par la Société.

3. OBLIGATIONS DU TESTEUR
3.1. Finalité de l'utilisation. Le Testeur s'engage à n'utiliser les Informations Confidentielles et la plateforme que dans le seul but d'évaluer l'opportunité d'une collaboration avec la Société et de réaliser les tests qui lui sont confiés.
3.2. Obligations générales. Le Testeur s'engage à :
• Ne divulguer, copier, reproduire ou transmettre aucune Information Confidentielle à un tiers sans autorisation écrite préalable de la Société ;
• Prendre toutes les mesures nécessaires pour protéger la confidentialité des informations reçues, avec le même degré de soin qu'il utilise pour ses propres informations confidentielles (et en tout état de cause un niveau au moins raisonnable) ;
• Restreindre l'accès aux Informations Confidentielles aux seules personnes ayant besoin d'en connaître pour les besoins des tests et préalablement informées de ces obligations de confidentialité ;
• Signaler immédiatement à la Société toute utilisation non autorisée, perte ou divulgation d'Informations Confidentielles, les signalements de vulnérabilités techniques étant régis par l'article 8.
3.3. Interdictions d'usage. Il est expressément interdit au Testeur d'utiliser les Informations Confidentielles, directement ou indirectement, pour :
• Réaliser une analyse concurrentielle ou comparative des produits de la Société ;
• Développer, concevoir ou commercialiser un produit ou service similaire ou concurrent ;
• Toute autre finalité que l'évaluation de la collaboration.

4. EXCLUSIONS
Ne sont pas considérées comme Informations Confidentielles les informations qui :
• Sont ou deviennent publiquement disponibles sans violation du présent NDA par le Testeur ;
• Étaient déjà en possession du Testeur avant la communication par la Société, comme en atteste une preuve écrite ;
• Sont développées indépendamment par le Testeur sans recours aux Informations Confidentielles ;
• Sont légalement obtenues auprès d'un tiers ayant le droit de les divulguer.

5. DURÉE DE L'OBLIGATION DE CONFIDENTIALITÉ
Les obligations de confidentialité s'appliquent pendant la durée du programme de test et survivent pendant une période de CINQ (5) ans après la fin de ce programme, quelle qu'en soit la cause,
sans préjudice de la protection des secrets d'affaires prévue par la loi n° 2018-670 du 30 juillet 2018, qui s'applique aussi longtemps que l'information demeure secrète.

6. NON-CONTOURNEMENT ET NON-DÉCOMPILATION
Le Testeur s'interdit expressément de :
• Désassembler, décompiler, déchiffrer ou procéder à toute ingénierie inverse des applications, code source ou algorithmes ;
• Contourner les mesures techniques de protection de la plateforme ;
• Tenter d'accéder à des données ou fonctionnalités non autorisées ;
• Copier, adapter ou créer des œuvres dérivées des Informations Confidentielles.

7. PROPRIÉTÉ INTELLECTUELLE
Tous les droits de propriété intellectuelle relatifs aux Informations Confidentielles restent la propriété exclusive de la Société. Le présent NDA ne confère au Testeur aucun droit, licence ou titre sur les Informations Confidentielles, à l'exception du droit limité d'y accéder pour les besoins des tests.

7 Bis. RETOURS ET SUGGESTIONS DU TESTEUR
Le Testeur s'engage à communiquer à la Société l'ensemble des retours, rapports de bug, suggestions, idées d'amélioration ou observations formulés dans le cadre du programme de test (ci-après « les Retours »).
Le Testeur concède à la Société, à titre gratuit, non exclusif et pour le monde entier, le droit d'utiliser, reproduire, adapter, intégrer et exploiter les Retours, sans restriction ni rémunération, dans le cadre du développement et de l'exploitation de ses produits et services.
Le Testeur garantit à la Société qu'il est l'auteur des Retours ou qu'il dispose des droits nécessaires pour consentir la présente concession.
Cette concession est consentie pour la durée légale de protection des droits concernés ou, à défaut, pour une durée de CINQ (5) ans à compter de la fin du programme de test.

8. SIGNALEMENT DES VULNÉRABILITÉS
Le Testeur s'engage à :
• Signaler toute vulnérabilité, faille de sécurité ou bug découvert exclusivement à la Société via le canal dédié (security@pesacore.fr) ;
• Ne pas exploiter, partager ou divulguer ces vulnérabilités à des tiers ;
• Ne pas tenter d'accéder aux données d'autres utilisateurs de la plateforme.

9. CONSÉQUENCES DE LA VIOLATION
Toute violation du présent NDA expose le Testeur à :
• L'exclusion immédiate et définitive du programme de test ;
• Des dommages et intérêts proportionnés au préjudice subi par la Société ;
• Des poursuites judiciaires (y compris en référé pour faire cesser la violation) ;
• Le remboursement des frais engagés par la Société pour faire respecter ses droits.

10. LOI APPLICABLE ET JURIDICTION
Le présent NDA est régi par le droit français. Si le Testeur est un professionnel, tout litige relatif à son interprétation ou son exécution relèvera de la compétence exclusive des tribunaux de Marseille, nonobstant pluralité de défendeurs ou appel en garantie.
Si le Testeur est un consommateur, les tribunaux compétents seront ceux prévus par les dispositions légales applicables.

11. CONDITIONS D'ACCÈS, ABSENCE DE GARANTIE ET LIMITATION DE RESPONSABILITÉ
11.1. Absence de garantie. Le Testeur reconnaît que la plateforme, les outils et les fonctionnalités mis à sa disposition dans le cadre du programme de test sont fournis « en l'état », en phase de développement ou de test, et peuvent contenir des erreurs, des bugs, des interruptions de service ou des pertes de données. La Société ne garantit pas que la plateforme fonctionnera sans interruption ni erreur, ni qu'elle répondra aux attentes du Testeur. Le Testeur est seul responsable de la sauvegarde de ses propres données et de l'usage qu'il fait de la plateforme pendant la phase de test.
11.2. Limitation de responsabilité de la Société (Testeur professionnel). Lorsque le Testeur est un professionnel, et dans les limites autorisées par le droit applicable, la responsabilité de la Société au titre du présent NDA ne pourra excéder un montant forfaitaire de DIX MILLE (10 000) EUROS, tous préjudices confondus. La Société ne pourra en aucun cas être tenue responsable des dommages indirects, pertes de données, pertes d'exploitation ou préjudices commerciaux subis par le Testeur.
11.3. Responsabilité de la Société (Testeur consommateur). Lorsque le Testeur est un consommateur, la responsabilité de la Société au titre du présent NDA n'est pas plafonnée et s'exerce dans les conditions prévues par le Code de la consommation et le Code civil. Les dispositions du présent article 11 ne font pas obstacle aux garanties légales dont bénéficie le consommateur.
11.4. Inclusions expresses. Les limitations de responsabilité prévues au présent article 11 s'appliquent expressément, sans restriction ni exclusion, aux conséquences financières des violations de données à caractère personnel imputables à la Société, dans les limites autorisées par le droit applicable.
11.5. Exceptions légales. Les limitations prévues au présent article ne s'appliquent pas en cas de dol, de faute lourde ou de dommage corporel, conformément au droit applicable.
11.6. Absence de plafond pour la responsabilité du Testeur. Les limitations prévues au présent article 11 ne s'appliquent qu'à la responsabilité de la Société. La responsabilité du Testeur au titre du présent NDA n'est pas plafonnée et s'exerce dans les conditions prévues à l'article 9.

12. PROTECTION DES DONNÉES PERSONNELLES
12.1. Qualité des parties. Dans le cadre du programme de test, le Testeur peut être amené à accéder à des données à caractère personnel, ou à en traiter pour le compte de la Société. Le cas échéant, le Testeur agit en qualité de sous-traitant au sens de l'article 28 du Règlement (UE) 2016/679 (RGPD) et de la loi n° 78-17 du 6 janvier 1978 modifiée.
Les obligations de confidentialité prévues à l'article 3 s'appliquent à tous les traitements de données à caractère personnel effectués dans ce cadre.
12.2. Obligations du Testeur en qualité de sous-traitant. Le Testeur s'engage à :
• Ne traiter les données à caractère personnel que sur instruction documentaire de la Société et pour les seules finalités du programme de test ;
• Mettre en œuvre les mesures techniques et organisationnelles appropriées pour garantir un niveau de sécurité adapté au risque, notamment en matière de confidentialité, d'intégrité, de disponibilité et de résilience des systèmes ;
• Veiller à ce que les personnes autorisées à traiter les données soient soumises à une obligation de confidentialité ;
• Ne pas transférer les données hors de l'Union européenne sans autorisation écrite préalable de la Société et sans garanties appropriées ;
• Aider la Société, dans la mesure du possible, à répondre aux demandes d'exercice des droits des personnes concernées ;
• Notifier à la Société toute violation de données à caractère personnel dans les meilleurs délais et au plus tard dans les quarante-huit (48) heures suivant sa constatation, afin de permettre à la Société de respecter ses obligations de notification à l'autorité de contrôle et, le cas échéant, aux personnes concernées ;
• Supprimer ou restituer à la Société l'ensemble des données à caractère personnel à la fin du programme de test, et détruire les copies existantes, sauf obligation légale de conservation.
12.3. Documentation et audits. Le Testeur tient à la disposition de la Société la documentation nécessaire pour démontrer le respect de ses obligations et permet à la Société de réaliser des audits, dans des conditions raisonnables et moyennant un préavis.
12.4. Sanctions. En cas de violation de données à caractère personnel imputable au Testeur, celui-ci supporte les conséquences financières et les éventuelles sanctions qui en résultent, dans les conditions prévues à l'article 9 du présent NDA.
12.5. Accès fortuits et incidents de cloisonnement. Le Testeur reconnaît que la plateforme est en phase de test et que des accès fortuits à des données à caractère personnel auxquelles il n'était pas destiné peuvent survenir (notamment en cas de bug, de faille de sécurité, ou de défaut d'isolation entre les espaces de travail – « tenants » – de la plateforme).
En cas d'accès fortuit à de telles données, le Testeur s'engage à :
• Ne pas consulter, exploiter, copier, conserver ni divulguer ces données au-delà de ce qui est strictement nécessaire pour constater l'incident ;
• Signaler immédiatement l'incident à la Société via le canal dédié (security@pesacore.fr), en précisant la nature des données concernées et les circonstances de l'accès ;
• Supprimer sans délai les données concernées de ses systèmes, et en attester par écrit à la Société sur demande ;
• Ne pas tenter de reproduire l'incident ni d'explorer les données concernées.
Les obligations du présent article 12.5 s'appliquent aux accès fortuits et ne font pas obstacle à l'application de l'article 6, qui réprime les tentatives d'accès intentionnelles non autorisées. Tout manquement aux obligations du présent article 12.5 constitue une violation grave du présent NDA.
12.6. Données saisies par le Testeur dans ses espaces de travail. Lorsque le Testeur crée un espace de travail (« tenant ») sur la plateforme et y saisit des données à caractère personnel, il agit en qualité de responsable de traitement au sens du RGPD pour ces données. La Société n'intervient alors qu'en qualité de fournisseur de la plateforme technique et ne détermine ni les finalités ni les moyens du traitement de ces données.
Le Testeur garantit à la Société qu'il dispose des bases légales nécessaires pour procéder à ces traitements et qu'il a informé les personnes concernées de l'utilisation de la plateforme à cette fin. Le Testeur s'engage à ne saisir dans la plateforme que les données strictement nécessaires aux tests et à privilégier, chaque fois que possible, des données synthétiques ou anonymisées.
Le Testeur garantit la Société contre toute réclamation, plainte ou sanction résultant d'un manquement à ses obligations de responsable de traitement.

Fait à [LIEU], le [DATE]
Pour PESACORE Architect : [SIGNATURE ÉLECTRONIQUE]
Le Testeur Bêta : [SIGNATURE ÉLECTRONIQUE]`;

// Composant principal
export default function NDA({ onAccept, onBack, isDark = true }) {
  const [visible, setVisible] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [signing, setSigning] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [pdfGenerating, setPdfGenerating] = useState(false);
  const [signatureId, setSignatureId] = useState(null);
  
  // État du formulaire
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: ''
  });
  
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  // Gestionnaire de changement des champs
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(null); // Efface l'erreur quand l'utilisateur modifie un champ
  };

  // Fonction d'enregistrement en base de données
  const registerAcceptance = async () => {
    setSigning(true);
    setError(null);

    // Validation des champs
    if (!formData.nom || !formData.prenom || !formData.email || !formData.telephone) {
      setError('Tous les champs sont obligatoires');
      setSigning(false);
      return;
    }

    // Validation email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Email invalide');
      setSigning(false);
      return;
    }

    // Validation téléphone (10 chiffres minimum)
    const phoneRegex = /^[0-9]{10,}$/;
    if (!phoneRegex.test(formData.telephone.replace(/\s/g, ''))) {
      setError('Téléphone invalide (10 chiffres minimum)');
      setSigning(false);
      return;
    }

    // Métadonnées collectées
    const acceptanceData = {
      nda_version: '1.0',
      accepted_at: new Date().toISOString(),
      acceptance_method: 'electronic_signature',
      tester_info: {
        nom: formData.nom,
        prenom: formData.prenom,
        email: formData.email.toLowerCase(),
        telephone: formData.telephone
      },
      ip_address: await fetchIpAddress(),
      user_agent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      timestamp: new Date().toISOString(),
    };

    try {
      // Envoi vers l'API backend avec axios
      const response = await api.post('/nda/sign', acceptanceData);

      // Avec axios, la réponse est directement dans response.data
      // Pas besoin de response.ok ni response.json()
      
      // Vérifier si la réponse est un succès
      if (response.data && response.data.success) {
        // Récupérer l'ID depuis response.data
        setSignatureId(response.data.data.acceptance_id);
        
        console.log('Acceptation enregistrée:', response.data);
        setSuccess(true);
        
        // Stockage local pour preuve légère
        localStorage.setItem('nda_acceptance', JSON.stringify({
          accepted: true,
          date: acceptanceData.accepted_at,
          version: acceptanceData.nda_version,
          tester: `${formData.prenom} ${formData.nom}`,
          email: formData.email
        }));
        
        setTimeout(() => {
          if (onAccept) {
            onAccept(acceptanceData);
          }
          if (onBack) {
            navigate(-1);
          }
        }, 2000);
      } else {
        throw new Error(response.data?.error || 'Erreur serveur');
      }
      
    } catch (err) {
      console.error('Erreur lors de l\'enregistrement:', err);
      
      // Gestion spécifique des erreurs axios
      if (err.response) {
        // Le serveur a répondu avec une erreur
        if (err.response.status === 409) {
          setError('Ce testeur a déjà signé le NDA. La signature est unique par email et téléphone.');
        } else {
          setError(err.response.data?.error || `Erreur serveur: ${err.response.status}`);
        }
      } else if (err.request) {
        // La requête a été faite mais pas de réponse
        setError('Impossible de contacter le serveur. Vérifiez votre connexion.');
      } else {
        // Autre erreur
        setError(err.message || 'Une erreur est survenue');
      }
    } finally {
      setSigning(false);
    }
  };

  // Fonction auxiliaire pour récupérer l'adresse IP (optionnelle)
  const fetchIpAddress = async () => {
    try {
      const res = await fetch('https://api.ipify.org?format=json');
      const data = await res.json();
      return data.ip;
    } catch (err) {
      return 'unavailable';
    }
  };

  const handleSign = () => {
    if (!accepted) {
      setError('Vous devez accepter les termes du NDA avant de signer.');
      return;
    }
    registerAcceptance();
  };

  const getNdaContentWithMetadata = () => {
    const aujourdhui = new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    
    const lieu = "France (signature électronique)";
    
    return NDA_CONTENT
      .replace(/Fait à \[LIEU\], le \[DATE\]/, `Version électronique faite depuis ${lieu}, le ${aujourdhui}`)
      .replace(/Pour PESACORE Architect : \[SIGNATURE ÉLECTRONIQUE\]/, 'Pour PESACORE Architect : (Signature électronique enregistrée)')
      .replace(/Le Testeur Bêta : \[SIGNATURE ÉLECTRONIQUE\]/, 'Le Testeur Bêta : (Signature électronique enregistrée)');
  };

  const downloadPdf = async () => {
    if (!signatureId) {
      setError('Aucune signature trouvée');
      return;
    }
    
    setPdfGenerating(true);
    setError(null);
    
    try {
      // Utilisation de api.get avec responseType blob pour le PDF
      const response = await api.get(`/nda/pdf/${signatureId}`, {
        responseType: 'blob'
      });
      
      // Créer un lien de téléchargement
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `NDA_${formData.prenom}_${formData.nom}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (err) {
      console.error('Erreur PDF:', err);
      if (err.response) {
        setError(err.response.data?.error || 'Erreur lors du téléchargement du PDF');
      } else {
        setError('Impossible de générer le PDF');
      }
    } finally {
      setPdfGenerating(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: T.bg,
      fontFamily: "'Inter', 'JetBrains Mono', monospace",
      color: T.text,
      position: "relative",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700;14..32,800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes pulse { 0%,100%{opacity:.4} 50%{opacity:1} }
        @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        .nda-container { animation: fadeUp 0.55s ease; }
      `}</style>

      {/* Grille fond */}
      <div style={{
        position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0,
        backgroundImage: `linear-gradient(to right,rgba(34,211,238,0.03) 1px,transparent 1px),linear-gradient(to bottom,rgba(245,158,11,0.03) 1px,transparent 1px)`,
        backgroundSize: "72px 72px",
        maskImage: "radial-gradient(ellipse at 50% 0%,black 30%,transparent 70%)",
      }} />

      {/* Header */}
      <header style={{
        height: "56px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        borderBottom: `1px solid ${T.border}`,
        background: "rgba(10,10,15,0.92)",
        backdropFilter: "blur(12px)",
        position: "sticky",
        top: 0,
        zIndex: 100,
        fontFamily: "'JetBrains Mono', monospace",
      }}>
        {/* Logo + Nom société */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{ position: 'relative', width: '32px', height: '32px', border: '1px solid rgba(245,158,11,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(245,158,11,0.04)' }}>
            <span style={{ position: 'absolute', top: '-1px', left: '-1px', width: '7px', height: '7px', borderTop: '2px solid #22d3ee', borderLeft: '2px solid #22d3ee' }} />
            <span style={{ position: 'absolute', bottom: '-1px', right: '-1px', width: '7px', height: '7px', borderBottom: '2px solid #f59e0b', borderRight: '2px solid #f59e0b' }} />
            <img src="/logo2026.png" alt="P" style={{ width: '20px', height: '20px', objectFit: 'contain', filter: 'brightness(1.2)' }} />
          </div>
          <span style={{ fontSize: "14px", fontWeight: 600, color: T.text, letterSpacing: "0.02em" }}>
            PESACORE Architect
          </span>
        </div>

        {/* Zone centrale - Indicateur NDA */}
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{
            display: "flex", alignItems: "center", gap: "8px",
            padding: "4px 12px",
            background: T.surfaceAlt,
            borderRadius: "4px", border: `1px solid ${T.border}`,
          }}>
            <div style={{ width: 7, height: 7, borderRadius: "50%", background: T.red, animation: "pulse 2s infinite" }} />
            <span style={{ fontSize: "11px", fontWeight: 600, color: T.textFaint, letterSpacing: "0.05em" }}>
              NDA · PROGRAMME TESTEUR
            </span>
          </div>
          <div style={{ width: 1, height: 28, background: T.border }} />
          <span style={{ fontSize: "11px", color: T.textFaint }}>v1.1 · 28 OCTOBRE 2026</span>
        </div>

        {/* Bouton Accueil */}
        <button
          onClick={() => navigate('/home-page')}
          style={{
            display: "flex", alignItems: "center", gap: 6,
            background: "none", border: `1px solid ${T.border}`,
            cursor: "pointer", color: T.textFaint,
            padding: "5px 12px", borderRadius: "4px",
            fontSize: "11px", fontWeight: 500,
            transition: "all 0.2s",
            fontFamily: "'JetBrains Mono', monospace",
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.orange; e.currentTarget.style.color = T.orange; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.textFaint; }}
        >
          🏠 Accueil
        </button>
      </header>

      {/* Contenu principal */}
      <div className="nda-container" style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "48px 24px 80px 24px",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.55s ease",
      }}>
        {/* Hero */}
        <div style={{ marginBottom: "40px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            padding: "5px 14px",
            borderRadius: "4px",
            background: T.orangeDim,
            border: `1px solid ${T.orange}25`,
            marginBottom: "24px",
          }}>
            <span style={{ fontSize: "11px", fontWeight: 700, color: T.orange, letterSpacing: "0.08em" }}>
              ▸ ACCORD DE NON-DIVULGATION
            </span>
            <span style={{ fontSize: "10px", color: T.red, animation: "pulse 2s infinite" }}>●</span>
          </div>

          <h1 style={{
            fontSize: "clamp(28px, 3.5vw, 38px)",
            fontWeight: 700,
            color: T.text,
            lineHeight: 1.15,
            letterSpacing: "-0.025em",
            marginBottom: "16px",
          }}>
            Accord de<br />
            <span style={{ color: T.orange }}>Non-Divulgation (NDA)</span>
          </h1>

          <p style={{
            fontSize: "14px",
            color: T.textMuted,
            lineHeight: 1.75,
            maxWidth: "560px",
            fontFamily: "'Inter', sans-serif",
          }}>
            En tant que testeur bêta de la plateforme PESACORE, vous vous engagez à respecter strictement les termes de cet accord.
            Veuillez remplir vos informations et lire attentivement avant de signer.
          </p>
        </div>

        {/* Zone du texte du NDA avec scroll */}
        <div style={{
          background: T.surfaceAlt,
          border: `1px solid ${T.border}`,
          borderRadius: "6px",
          padding: "24px",
          marginBottom: "32px",
          maxHeight: "400px",
          overflowY: "auto",
        }}>
          <pre style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "13px",
            lineHeight: "1.7",
            color: T.textMuted,
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            margin: 0,
          }}>
            {getNdaContentWithMetadata()}
          </pre>
        </div>

        {/* Formulaire testeur */}
        <div style={{
          background: T.surfaceAlt,
          border: `1px solid ${T.border}`,
          borderRadius: "6px",
          padding: "24px",
          marginBottom: "24px",
        }}>
          <h3 style={{ 
            marginBottom: "20px", 
            color: T.orange, 
            fontSize: "16px",
            fontFamily: "'JetBrains Mono', monospace"
          }}>
            📋 Vos informations
          </h3>
          
          <div style={{ display: "grid", gap: "16px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: T.textMuted }}>
                  Prénom *
                </label>
                <input
                  type="text"
                  name="prenom"
                  value={formData.prenom}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: "10px",
                    background: T.bg,
                    border: `1px solid ${T.border}`,
                    borderRadius: "4px",
                    color: T.text,
                    fontSize: "14px"
                  }}
                  required
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: T.textMuted }}>
                  Nom *
                </label>
                <input
                  type="text"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: "10px",
                    background: T.bg,
                    border: `1px solid ${T.border}`,
                    borderRadius: "4px",
                    color: T.text,
                    fontSize: "14px"
                  }}
                  required
                />
              </div>
            </div>
            
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: T.textMuted }}>
                Email *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  background: T.bg,
                  border: `1px solid ${T.border}`,
                  borderRadius: "4px",
                  color: T.text,
                  fontSize: "14px"
                }}
                required
              />
            </div>
            
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: T.textMuted }}>
                Téléphone *
              </label>
              <input
                type="tel"
                name="telephone"
                value={formData.telephone}
                onChange={handleInputChange}
                placeholder="0612345678"
                style={{
                  width: "100%",
                  padding: "10px",
                  background: T.bg,
                  border: `1px solid ${T.border}`,
                  borderRadius: "4px",
                  color: T.text,
                  fontSize: "14px"
                }}
                required
              />
            </div>
          </div>
        </div>

        {/* Zone d'acceptation */}
        <div style={{
          background: `${T.emerald}08`,
          border: `1px solid ${T.emerald}20`,
          borderRadius: "6px",
          padding: "24px",
        }}>
          {/* Case à cocher obligatoire */}
          <div style={{ marginBottom: "24px" }}>
            <label style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              cursor: "pointer",
            }}>
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => {
                  setAccepted(e.target.checked);
                  setError(null);
                }}
                style={{
                  width: "20px",
                  height: "20px",
                  marginTop: "2px",
                  cursor: "pointer",
                  accentColor: T.orange,
                }}
              />
              <span style={{
                fontSize: "14px",
                lineHeight: "1.6",
                color: T.text,
                fontFamily: "'Inter', sans-serif",
              }}>
                <strong style={{ color: T.orange }}>Je déclare avoir lu et compris l'intégralité de cet Accord de Non-Divulgation</strong> et je m'engage à respecter toutes ses clauses, notamment l'obligation de confidentialité pendant toute la durée du programme de test et les 5 années suivant son terme.
              </span>
            </label>
          </div>

          {/* Message d'erreur */}
          {error && (
            <div style={{
              marginBottom: "20px",
              padding: "12px 16px",
              background: `${T.red}15`,
              border: `1px solid ${T.red}40`,
              borderRadius: "4px",
              color: T.red,
              fontSize: "13px",
              fontFamily: "'Inter', sans-serif",
            }}>
              ⚠️ {error}
            </div>
          )}

          {/* Message de succès */}
          {success && (
            <div style={{
              marginBottom: "20px",
              padding: "16px",
              background: `${T.emerald}15`,
              border: `1px solid ${T.emerald}40`,
              borderRadius: "4px",
              color: T.emerald,
              fontSize: "13px",
              fontFamily: "'Inter', sans-serif",
              textAlign: "center"
            }}>
              <div style={{ marginBottom: "8px", fontWeight: "bold" }}>
                ✓ NDA signé avec succès !
              </div>
              <div style={{ fontSize: "12px", color: T.textMuted, marginBottom: "16px" }}>
                Merci {formData.prenom} {formData.nom}, votre signature a été enregistrée.
              </div>
              
              {/* Bouton PDF */}
              <button
                onClick={downloadPdf}
                disabled={pdfGenerating}
                style={{
                  padding: "10px 24px",
                  background: T.orange,
                  border: "none",
                  borderRadius: "4px",
                  color: "#0A0A0F",
                  fontSize: "13px",
                  fontWeight: 600,
                  fontFamily: "'JetBrains Mono', monospace",
                  cursor: pdfGenerating ? "not-allowed" : "pointer",
                  opacity: pdfGenerating ? 0.6 : 1,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                {pdfGenerating ? '⏳ Génération...' : '📄 Télécharger mon NDA (PDF)'}
              </button>
              
              <div style={{ fontSize: "11px", color: T.textFaint, marginTop: "12px" }}>
                Un email de confirmation a été envoyé à l'administrateur.
              </div>
            </div>
          )}

          {/* Bouton de signature */}
          <button
            onClick={handleSign}
            disabled={!accepted || signing || success}
            style={{
              width: "100%",
              padding: "14px 24px",
              background: !accepted || signing || success ? T.textFaint : T.orange,
              border: "none",
              borderRadius: "4px",
              color: !accepted || signing || success ? T.textMuted : '#0A0A0F',
              fontSize: "14px",
              fontWeight: 700,
              fontFamily: "'JetBrains Mono', monospace",
              letterSpacing: "0.03em",
              cursor: (!accepted || signing || success) ? "not-allowed" : "pointer",
              transition: "all 0.2s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
            onMouseEnter={e => {
              if (accepted && !signing && !success) {
                e.currentTarget.style.background = '#FFA759';
              }
            }}
            onMouseLeave={e => {
              if (accepted && !signing && !success) {
                e.currentTarget.style.background = T.orange;
              }
            }}
          >
            {signing ? 'Enregistrement en cours...' : success ? '✓ Accepté et signé' : '✎ J’accepte et je signe'}
          </button>

          <p style={{
            marginTop: "16px",
            fontSize: "11px",
            color: T.textFaint,
            textAlign: "center",
            fontFamily: "'JetBrains Mono', monospace",
          }}>
            La signature électronique a la même valeur juridique qu'une signature manuscrite
            (Règlement eIDAS n°910/2014)
          </p>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: "32px",
          padding: "16px 20px",
          borderRadius: "4px",
          background: T.surfaceAlt,
          border: `1px solid ${T.border}`,
          fontSize: "11px",
          color: T.textFaint,
          textAlign: "center",
          fontFamily: "'JetBrains Mono', monospace",
        }}>
          PESACORE Architect — Tous droits réservés | NDA v1.0 | 09 avril 2026
        </div>
      </div>
    </div>
  );
}